import React, { useState } from "react";
import CustomModal from "./CustomModal";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";
import Vs from "../../assets/VsIcon.svg";
import { mapAbbrToLogo, mapAbbrToLogoWithURL } from "../../types/type";
import { MatchType } from "../MatchHeaderDropdown";

type MyPicksModalProps = {
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onSeePicks?: () => void;
  team1Logo: string;
  team2Logo: string;
  match: MatchType;
  lauchRegistration: () => void;
};

const MyPicksModal: React.FC<MyPicksModalProps> = ({
  modalVisible,
  setModalVisible,
  onSeePicks,
  team1Logo,
  team2Logo,
  match,
  lauchRegistration,
}) => {
  const handeOnSeePicks = () => {
    if (onSeePicks) {
      onSeePicks();
    }
    setModalVisible(false);
  };

  return (
    <CustomModal
      modalVisible={modalVisible}
      height="250px"
      setModalVisible={setModalVisible}
    >
      <div className="modalContainer itemsCenter modalContentSpaceBetween">
        <div className="modalMyPickModalTop">
          <img
            src={team1Logo && mapAbbrToLogoWithURL(match, false).logo}
            alt=""
            className="modalMyPicksModalLogo"
          />
          <img src={Vs} alt="" className="" />
          <img
            src={team2Logo && mapAbbrToLogoWithURL(match, true).logo}
            alt=""
            className="modalMyPicksModalLogo"
          />
        </div>
        <CustomText color={Colors.primary} size="large" weight="700">
          {match.is_played ? "Go To Picks!" : "Match has started"}
        </CustomText>
        <div className="" onMouseDown={handeOnSeePicks}>
          <CustomText color="#8EA0BD" size="small" weight="500">
            See your picks
          </CustomText>
        </div>

        <button
          onMouseDown={handeOnSeePicks}
          onClick={handeOnSeePicks}
          className="buttonRegistrationSubmitButton"
        >
          <CustomText color={Colors.white} size="smallMedium" weight="700">
            MY PICKS
          </CustomText>
        </button>
      </div>
    </CustomModal>
  );
};

export default MyPicksModal;
